<template>
    <SettingSection>
        <div class="flex justify-between items-center">
            <!-- title and description -->
            <div class="mr3">
                <h6>{{title}}</h6>
                <div class="legal mt1">{{description}}</div>
            </div>

            <!-- checkboxes -->
            <div class="flex items-center">
                <div>
                    <Checkbox v-model="notifications.send_sms" class="tc"/>
                </div>
                <div class="w2 w3-ns tr ml3 ml4-ns">
                    <Checkbox v-model="notifications.send_email" class="tc dib"/>
                </div>
            </div>
            
        </div>
    </SettingSection>
</template>

<script>
import Checkbox from '@/components/controls/Checkbox.vue';
import SettingSection from '@/components/accountSettings/shared/SettingSection.vue';

export default {
    components: {
        Checkbox,
        SettingSection
    },
    props: {
        title: {
            type: String
        },
        description: {
            type: String
        },
        notifications: {
            type: Object
        }
    }
};
</script>
